(() => {
  const REFRESH_PARAM = '__pev_refresh';
  const STORAGE_KEY_PATTERN = /^(pev|theme|shopify|recently|predictive|localization)/i;

  const setButtonState = (button, text, disabled) => {
    if (!button) return;
    button.disabled = disabled;
    const label = button.querySelector('[data-pev-refresh-label]');
    if (label) label.textContent = text;
    else button.textContent = text;
  };

  const clearThemeStorage = () => {
    try {
      window.sessionStorage.clear();
    } catch (error) {
      console.debug('Session storage could not be cleared.', error);
    }

    try {
      const keys = [];
      for (let index = 0; index < window.localStorage.length; index += 1) {
        const key = window.localStorage.key(index);
        if (key && STORAGE_KEY_PATTERN.test(key)) keys.push(key);
      }
      keys.forEach((key) => window.localStorage.removeItem(key));
    } catch (error) {
      console.debug('Theme storage could not be cleared.', error);
    }
  };

  const clearBrowserCaches = async () => {
    const jobs = [];

    if ('caches' in window) {
      jobs.push(
        window.caches.keys().then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))))
      );
    }

    if ('serviceWorker' in navigator) {
      jobs.push(
        navigator.serviceWorker
          .getRegistrations()
          .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      );
    }

    await Promise.allSettled(jobs);
  };

  const refreshLatestSite = async (button) => {
    setButtonState(button, 'Refreshing…', true);
    clearThemeStorage();

    try {
      await clearBrowserCaches();
    } catch (error) {
      console.debug('Browser caches could not be fully cleared.', error);
    }

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set(REFRESH_PARAM, Date.now().toString());
    nextUrl.hash = '';
    window.location.replace(nextUrl.toString());
  };

  const init = () => {
    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.has(REFRESH_PARAM)) {
      currentUrl.searchParams.delete(REFRESH_PARAM);
      window.history.replaceState({}, document.title, currentUrl.toString());
    }

    document.querySelectorAll('[data-pev-refresh-site]').forEach((button) => {
      button.hidden = false;
      button.addEventListener('click', () => refreshLatestSite(button));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
